import { has, trySetProp } from '../global.functions';
import { Validator } from '../services/model/form-service.model';
import { Qualifier } from './application.model';
import { AccessLevel, MappedField } from './common.model';
import { iApplyFormControl } from './control.model';
import { ITruthCondition } from './truth-condition.model';
import { ServiceEndpointUtilisation } from './workflow.model';

export const ControlTypeInfo = [
    // badge: { title: 'new', classes: 'px-2 bg-pink-600 text-white rounded-full' } },
    { controltype: 'text', title: 'Textarea', icon: 'iapply_toolbox:control-textarea' },
    { controltype: 'combo', title: 'Select / Combo', icon: 'iapply_toolbox:control-combo' },
    { controltype: 'radio', title: 'Radio group', icon: 'iapply_toolbox:control-radio' },
    { controltype: 'checkbox', title: 'Checkbox', icon: 'iapply_toolbox:control-checkbox' },
    { controltype: 'checkboxgroup', title: 'Checkbox Group', icon: 'iapply_toolbox:control-checkboxgroup' },
    { controltype: 'datepicker', title: 'Date', icon: 'iapply_toolbox:control-datepicker' },
    { controltype: 'timepicker', title: 'Time', icon: 'iapply_toolbox:control-timepicker' },
    { controltype: 'label', title: 'Label', icon: 'iapply_toolbox:control-label' },
    { controltype: 'heading', title: 'Heading', icon: 'iapply_toolbox:control-heading' },
    { controltype: 'filebrowser', title: 'File Upload', icon: 'iapply_toolbox:control-filebrowser' },
    { controltype: 'html', title: 'HTML Content', icon: 'iapply_toolbox:control-html' },
    { controltype: 'group', title: 'Control Group', icon: 'iapply_toolbox:control-group' },
    { controltype: 'repeater', title: 'Repeater Group', icon: 'iapply_toolbox:control-repeater' },
    { controltype: 'hidden', title: 'Hidden Control', icon: 'iapply_toolbox:control-hidden' },
    { controltype: 'calculation', title: 'Calculation', icon: 'iapply_toolbox:control-calculation' },
    { controltype: 'signaturepad', title: 'Signature Pad', icon: 'iapply_toolbox:control-signaturepad' },
    { controltype: 'geolocation', title: 'GeoLocation', icon: 'iapply_toolbox:control-geolocation' },
    { controltype: 'search', title: 'Dynamic Search', icon: 'iapply_toolbox:control-search' },
    { controltype: 'summary', title: 'Summary Table', icon: 'iapply_toolbox:control-summary' },
    { controltype: 'likert', title: 'Likert Scale', icon: 'iapply_toolbox:control-likert' },
    { controltype: 'creditcard', title: 'Online Payment', icon: 'iapply_toolbox:control-creditcard' },
    { controltype: 'photobooth', title: 'Photo Booth', icon: 'iapply_toolbox:control-photobooth' },
    { controltype: 'docgen', title: 'DocGen', icon: 'iapply_toolbox:control-docgen' },
    { controltype: 'twofactorverification', title: 'Mobile Verification', icon: 'iapply_toolbox:control-twofactorverification' },
    { controltype: 'barcodescanner', title: 'Barcode Scanner', icon: 'iapply_toolbox:control-barcodescanner' },
    { controltype: 'digitalid', title: 'Digital ID', icon: 'iapply_toolbox:control-digitalid' },
];

export enum RepeaterDisplayStyle {
    Table = 'table',
    Vertical = 'vertical',
    Page = 'page',
}

export enum AmountValueFormat {
    Dollars = 'dollars',
    Cents = 'cents'
}

export enum CybersourceEnvironment {
    Test = 'test',
    Prod = 'prod'
}

export enum OptionPropEnum {
    Value = 'value',
    Description = 'description'
}

/** Control type enumeration. */
export enum ControlType {
    Unknown = 'Unknown',
    Barcodescanner = 'barcodescanner',
    Calculation = 'calculation',
    Checkbox = 'checkbox',
    Checkboxgroup = 'checkboxgroup',
    Combo = 'combo',
    Creditcard = 'creditcard',
    Cybersource = 'cybersource',
    Datepicker = 'datepicker',
    DigitalId = 'digitalid',
    Docgen = 'docgen',
    Filebrowser = 'filebrowser',
    Geolocation = 'geolocation',
    Group = 'group',
    Heading = 'heading',
    Hidden = 'hidden',
    Html = 'html',
    Label = 'label',
    Likert = 'likert',
    Photobooth = 'photobooth',
    Radio = 'radio',
    Repeater = 'repeater',
    Search = 'search',
    Signaturepad = 'signaturepad',
    Summary = 'summary',
    Text = 'text',
    TextArea = 'textarea',
    Timepicker = 'timepicker',
    Twofactorverification = 'twofactorverification',
    Page = 'page',
}

export enum ControlSize {
    ExtraSmall = 'xs',
    Small = 's',
    Medium = 'm',
    Large = 'l',
    ExtraLarge = 'xl',
}

export enum CarouselStyle {
    SingleItem = 'SingleItem',
    MultipleItems = 'MultipleItems',
    CenterMode = 'CenterMode',
    SliderSyncing = 'SliderSyncing',
}

export enum InputType {
    Email = 'email',
    Number = 'number',
    Tel = 'tel',
    URL = 'url',
}

export enum AutoCapitaliseOptions {
    None = 'none',
    Sentences = 'sentences',
    Words = 'words',
    Characters = 'characters',
}

export enum BarcodeType {
    QRCode = 'qr',
    EAN8 = 'ean8',
    EAN13 = 'ean13',
    Code39 = '39',
    Code128 = '128',
    ITF = 'itf',
    RSS14 = 'rss14',
    DATAMATRIX = 'datamatrix',
    AZTEC = 'aztec',
    PDF417 = 'pdf417',
}

export enum PaymentGateway {
    BPoint = 'BPoint',
    Bpoint3 = 'BPoint3',
    PayWay = 'PayWay',
    QuickWeb = 'QuickWeb',
}

export enum PaymentGatewayEnvironment {
    UAT = 'uat',
    Production = 'production',
}

export enum GeolocationDisplayStyle {
    Coordinates = 'coordinates',
    Map = 'map',
    Both = 'both',
    None = 'none',
}

export enum DefaultPermissionsTo {
    Previous = 'Previous',
    Future = 'Future',
    All = 'All',
    No = 'No',
}

export enum PhotoSize {
    Small = 's',
    Medium = 'm',
    Large = 'l',
}

export enum PhotoOrientation {
    Portrait = 'portrait',
    Landscape = 'landscape',
}

export enum LikertValues {
    StronglyDisagree = 'Strongly Disagree',
    Disagree = 'Disagree',
    Neutral = 'Neutral',
    Agree = 'Agree',
    StronglyAgree = 'Strongly Agree',
}

export interface IOptionSource {
    type: OptionSourceType;
    options: ControlValueOption[] | undefined;
    sort: string | undefined;
}

export class LikertScaleItem {
    value: string;
    description: string;

    public constructor(data?: LikertScaleItem) {
        if (data) {
            trySetProp(this, data, 'Value');
            trySetProp(this, data, 'Description');
        }
    }

    init(data?: any) {
        if (data) {
            trySetProp(this, data, 'Value');
            trySetProp(this, data, 'Description');
        }
    }

    static fromJS(data: any): LikertScaleItem {
        data = typeof data === 'object' ? data : {};
        let result = new LikertScaleItem();
        result.init(data);
        return result;
    }
}

export class ControlSubField {
    name: string;
    label: string;

    public constructor(data?: ControlSubField) {
        if (data) {
            trySetProp(this, data, 'Name');
            trySetProp(this, data, 'Label');
        }
    }

    init(data?: any) {
        if (data) {
            trySetProp(this, data, 'Name');
            trySetProp(this, data, 'Label');
        }
    }

    static fromJS(data: any): ControlSubField {
        data = typeof data === 'object' ? data : {};
        let result = new ControlSubField();
        result.init(data);
        return result;
    }
}

export enum OptionSourceType {
    Static = 'Static',
    Prebuilt = 'Prebuilt',
    Dynamic = 'Dynamic',
    Repeater = 'Repeater',
    System = 'System',
}

export enum Switch {
    Off = 'off',
    On = 'on',
}

/** The metadata for a control. */
export interface IControl {
    visibilityRule: ITruthCondition | undefined;
    /** Gets or sets the control id. */
    id: number;
    /** Gets or sets the control name. */
    name: string | undefined;
    /** Gets or sets the position on the page. */
    sortPosition: number;
    /** Gets or sets the parent control id. */
    parentControlId: number | undefined;
    /** Gets or sets control notes.
The Notes property is available in the Workbench only and can be used to record comments or explanations. */
    notes: string | undefined;
    type: ControlType;
    /** Gets or sets the controls AccessLevel */
    access: AccessLevel;
}

export interface IFormControl extends IControl {
    // If this control implements IValueControl it's capable of storing a value.
    isValueControl: boolean;

    // If the control is an option control, it stores a list of values in a n option list, or retrieves from an external source.
    isOptionControl: boolean;

    // If the control allows MANUAL data input (requiring validation)
    isInputControl: boolean;

    // Is control group determines if the control contains child controls.
    isControlGroup: boolean;
}

export interface ICarouselControl extends IControl {
    displayAsCarousel: boolean;
    carouselStyle: CarouselStyle;
}

export interface IContainerControl extends IControl {
    readonly isControlGroup: boolean;
    label: string;
    controls: iApplyFormControl[];
}

export interface IGroupControl extends IContainerControl {
    readonly isControlGroup: boolean;
    backgroundImage: string;
    backgroundColor: string;
    fontColor: string;
    buttonLabel: string;
}

export function isContainerControl(control: IControl): control is IContainerControl {
    return control && has(control, 'controls');
}

export function isGroupControl(control: IControl): control is IGroupControl {
    return control
        && has(control, 'controls')
        && has(control, 'backgroundImage')
        && has(control, 'backgroundColor')
        && has(control, 'fontColor')
        && has(control, 'buttonLabel');
}

export enum ApplicationDataType {
    ValueObject = 'value_object',
    ValueArray = 'value_object_array'
}

export type ValueDescriptionPair = {
    value: string;
    description: string;
}

export type DataContainer = {
    $$qualifier?: Qualifier;
    [fieldname: string]: any; // string | string[] | DataContainer | DataContainer[] | IApplicationDataObject | Qualifier
}

export function isDataArrayWithKey(container: DataContainer, key: string) {
    return container && (Array.isArray(container) && container.find(row => Object.hasOwn(row, key)) !== undefined);
}

export function isDataObjectWithKey(container: DataContainer, key: string) {
    return container && (!Array.isArray(container) && Object.hasOwn(container, key));
}

export function dataContainerHasKey(container: DataContainer, key: string) {
    return isDataArrayWithKey(container, key) || isDataObjectWithKey(container, key);
}


export interface IApplicationDataObject {
    _type: ApplicationDataType;
    value?: string;
    description?: string;
    values?: ValueDescriptionPair[];

    toObject(): any;
}

export function isApplicationDataObject(obj: any): obj is IApplicationDataObject {
    return obj
        && Object.hasOwn(obj, '_type')
        && [ApplicationDataType.ValueArray, ApplicationDataType.ValueObject].includes(obj._type);
}

export class ApplicationDataObject implements IApplicationDataObject {
    _type: ApplicationDataType = ApplicationDataType.ValueObject;
    value: string = '';
    description: string = '';

    constructor(data?: { value?: string, description?: string }) {
        this.value = data?.value || '';
        this.description = data?.description || '';
    }

    toObject() {
        return { ...this };
    }
}
export class ApplicationDataArray implements IApplicationDataObject {
    _type: ApplicationDataType = ApplicationDataType.ValueArray;
    values: ValueDescriptionPair[] = [];

    constructor(values?: ValueDescriptionPair[]) {
        if (values) {
            this.values = values;
        }
    }

    toObject() {
        return { ...this };
    }
}

export interface IControlWithObjectData {
    // isObjectValueControl: boolean;
    valueTemplate: IApplicationDataObject;
}

export function isControlWithObjectData(control: any): control is IControlWithObjectData {
    return control && has(control, 'valueTemplate');
}

export interface IControlWithDefaultValue {
    defaultValue: string;
}

export function isControlWithDefaultValue(
    control: any
): control is IControlWithDefaultValue {
    return (
        control &&
        has(control, 'defaultValue') &&
        typeof control.defaultValue == 'string'
    );
}

export interface IControlWithLabel {
    label: string;
}

export function isControlWithLabel(control: any): control is IControlWithLabel {
    return control && has(control, 'label') && typeof control.label == 'string';
}

export interface IControlWithContent {
    content: string;
}

export interface IControlWithPlaceholder {
    placeholder: string;
}

export function isControlWithPlaceholder(
    control: any
): control is IControlWithPlaceholder {
    return (
        control &&
        has(control, 'placeholder') &&
        typeof control.placeholder == 'string'
    );
}

export interface IControlWithDates {
    minDate: string;
    maxDate: string;
}

export function isControlWithDates(control: any): control is IValueControl {
    return control && has(control, 'minDate') && has(control, 'maxDate');
}

export interface IControlWithBarCode {
    navigateOnSuccess: boolean;
    scanWidth: number | undefined;
    scanHeight: number | undefined;
    scanBarcodeLabel: string | undefined;
    barcodeType: BarcodeType;
    displayValue: boolean;
}

export function isControlWithBarCode(control: any): control is IValueControl {
    return (
        control &&
        has(control, 'navigateOnSuccess') &&
        has(control, 'scanWidth') &&
        has(control, 'scanHeight') &&
        has(control, 'scanBarcodeLabel') &&
        has(control, 'barcodeType') &&
        has(control, 'displayValue')
    );
}

export interface ISearchControl {
    retainValue: boolean;
    staticOption: boolean;
    staticOptionMessage: string;
    searchDisplayField: string | undefined;
    autoSelectSingleResult: boolean;
    manualSearch: boolean;
    floating: boolean;
    minimumInputLength: number | undefined;
    triggerSaveEvent: boolean;
    searchAgainAndClear: boolean;
    searchSource: ServiceEndpointUtilisation;
}

export function isSearchControl(control: any): control is ISearchControl {
    return control && has(control, 'searchSource');
    // has(control, 'minimumInputLength') &&
    // has(control, 'retainValue') &&
    // has(control, 'staticOptionMessage') &&
    // has(control, 'autoSelectSingleResult') &&
    // has(control, 'searchDisplayField') &&
    // has(control, 'floating') &&
    // has(control, 'manualSearch') &&
    // has(control, 'triggerSaveEvent') &&
    // has(control, 'searchAgainAndClear') &&
}

export interface IControlWithRows {
    rows: number;
}

export function isControlWithRows(control: any): control is IControlWithRows {
    return control && has(control, 'rows') && typeof control.rows == 'number';
}

export interface IControlWithSize {
    size: ControlSize;
}

export const isControlWithSize = (
    control: any
): control is IControlWithSize => {
    return Object.hasOwn(control, 'size') && typeof control.size == 'string';
};

export interface IControlWithToolTip {
    tooltip: string;
}

export function isControlWithToolTip(
    control: any
): control is IControlWithToolTip {
    return (
        control && has(control, 'tooltip') && typeof control.tooltip == 'string'
    );
}

export interface IControlWithValidators {
    validators: ControlRegexValidator[];
}

export function isControlWithValidators(
    control: any
): control is IControlWithValidators {
    return (control && has(control, 'validators'));
}

export interface IIndexableControl {
    isIndexedField: boolean;
}

export function isControlIndexable(control: any): control is IIndexableControl {
    return (
        control &&
        has(control, 'isIndexedField') &&
        typeof control.isIndexedField == 'boolean'
    );
}

export interface IValuePersistableControl extends iApplyFormControl {
    persistValue: boolean;
}

export function isControlPersistable(
    control: any
): control is IValuePersistableControl {
    return (
        control &&
        has(control, 'persistValue') &&
        typeof control.persistValue == 'boolean'
    );
}

export interface IControlGeoLocation {
    displayStyle: GeolocationDisplayStyle;
}

export function isControlGeoLocation(
    control: any
): control is IControlGeoLocation {
    return control
        && control.type == ControlType.Geolocation
        && has(control, 'displayStyle');
}

export interface IFileBrowserControl {
    allowedFileTypes: FileType[];
    maximumFileSizePerFile: number;
    maximumFileUploadCount: number;
}

export function isControlFileBrowser(
    control: any
): control is IFileBrowserControl {
    return (
        control &&
        has(control, 'allowedFileTypes') &&
        has(control, 'maximumFileSizePerFile') &&
        has(control, 'maximumFileUploadCount')
    );
}

export interface IControlPrePopulate {
    allowPrePopulate: boolean;
}

export function isControlPrePopulate(
    control: any
): control is IControlPrePopulate {
    return control && has(control, 'allowPrePopulate');
}

export interface IValueControl {
    label: string | undefined;
    mandatory: boolean;
    mandatoryMessage: string | undefined;
}

export function isValueControl(control: any): control is IValueControl {
    return (
        control &&
        has(control, 'label') &&
        has(control, 'mandatory') &&
        typeof control.label == 'string' &&
        typeof control.mandatory == 'boolean'
    );
}

export interface IControlWithOptions extends iApplyFormControl {
    optionFilterControl: string;
    allowMultipleSelect: boolean;
    optionSourceType: OptionSourceType;
    optionSource: IOptionSource;
    options: ControlValueOption[];
}

export function isControlWithOptions(
    control: any
): control is IControlWithOptions {
    return (
        control &&
        has(control, 'optionFilterControl') &&
        has(control, 'allowMultipleSelect') &&
        has(control, 'optionSource') &&
        has(control, 'options') &&
        typeof control.optionSource == 'object' &&
        typeof control.optionFilterControl == 'string' &&
        typeof control.allowMultipleSelect == 'boolean'
    );
}

/** A control regular expression validator reference. */
export class ControlRegexValidator {
    /** The validator ID. */
    validatorId!: string;
    /** The error message template. */
    message: string;

    /** The concrete validator resolved from the server when required for use. */
    validator: Validator;

    public constructor(data?: IControlRegexValidator) {
        if (data) {
            trySetProp(this, data, 'ValidatorId');
            trySetProp(this, data, 'Message');
        }
    }

    init(_data?: any) {
        if (_data) {
            trySetProp(this, _data, 'ValidatorId');
            trySetProp(this, _data, 'Message');
        }
    }

    static fromJS(data: any): ControlRegexValidator {
        data = typeof data === 'object' ? data : {};
        let result = new ControlRegexValidator();
        result.init(data);
        return result;
    }
}

export interface IControlRegexValidator {
    /** The validator ID. */
    validatorId: string;
    /** The error message template. */
    message: string;
}

export function isControlRegexValidator(control: any): control is IControlRegexValidator {
    return (
        control &&
        has(control, 'validatorId') &&
        has(control, 'message') &&
        typeof control.validatorId == 'string' &&
        typeof control.message == 'string'
    );
}

export class ControlValueOption {
    value: string = '';
    description: string = '';
    category: string = null;
    score: number = 0;
    imageId: number | undefined = null;
    image: string = null;
    content: string = null;

    public constructor(init?: Partial<ControlValueOption>) {
        Object.assign(this, init);
    }

    static fromJS(data: any): ControlValueOption {
        return new ControlValueOption({
            value: data['Value'],
            description: data['Description'],
            category: data['Category'],
            score: data['Score'],
            imageId: data['ImageId'],
            image: data['Image'],
            content: data['Content'],
        });
    }
}

export class MobileKeyboardOptions {
    autocapitalise: AutoCapitaliseOptions = AutoCapitaliseOptions.None;
    autocomplete: Switch | undefined;
    spellcheck: boolean = false;
    autocorrect: Switch | undefined;

    init(_data?: any) {
        trySetProp(this, _data, 'Autocapitalise');
        trySetProp(this, _data, 'Autocomplete');
        trySetProp(this, _data, 'Spellcheck');
        trySetProp(this, _data, 'Autocorrect');
    }

    static fromJS(data: any): MobileKeyboardOptions {
        data = typeof data === 'object' ? data : {};
        let result = new MobileKeyboardOptions();
        result.init(data);
        return result;
    }
}

export class StaticOptionSource implements IOptionSource {
    type: OptionSourceType = OptionSourceType.Static;
    options: ControlValueOption[] = [];
    sort: string | undefined;

    static fromJS(data?: any): StaticOptionSource {
        let result = new StaticOptionSource();
        if (data) {
            result.type = data['Type'];
            result.sort = data['Sort'];
            if (Array.isArray(data['Options'])) {
                result.options = data['Options'].map(ControlValueOption.fromJS);
            }
        }

        return result;
    }
}

export class PrebuildOptionSource implements IOptionSource {
    type: OptionSourceType = OptionSourceType.Prebuilt;
    listId: string;
    options: ControlValueOption[] = [];
    sort: string | undefined;
}

export class DynamicOptionSource implements IOptionSource {
    type: OptionSourceType = OptionSourceType.Dynamic;
    options: ControlValueOption[] = [];
    sort: string | undefined;
    requestFieldMap: MappedField[] = [];
    responseFieldMap: MappedField[] = [];
    serviceEndpointId: string | undefined;

    static fromJS(data?: any): DynamicOptionSource {
        let result = new DynamicOptionSource();
        if (data) {
            result.type = data['Type'];
            result.sort = data['Sort'];
            result.serviceEndpointId = data['ServiceEndpointId'];
            if (Array.isArray(data['Options'])) {
                result.options = data['Options'].map(ControlValueOption.fromJS);
            }
            if (Array.isArray(data['RequestFieldMap'])) {
                result.requestFieldMap = data['RequestFieldMap'].map(MappedField.fromJS);
            }
            if (Array.isArray(data['ResponseFieldMap'])) {
                result.responseFieldMap = data['ResponseFieldMap'].map(MappedField.fromJS);
            }
        }

        return result;
    }
}

export class RepeaterOptionSource implements IOptionSource {
    type: OptionSourceType = OptionSourceType.Dynamic;
    options: ControlValueOption[] = [];
    sort: string | undefined;
    repeaterName: string;
    descriptionFields: string[] = [];
    valueFields: string[] = [];
    categoryField: string | undefined;

    static fromJS(data?: any): RepeaterOptionSource {
        let result = new RepeaterOptionSource();
        if (data) {
            result.type = data['Type'];
            result.sort = data['Sort'];
            result.repeaterName = data['RepeaterName'];
            result.categoryField = data['CategoryField'];
            if (Array.isArray(data['Options'])) {
                result.options = data['Options'].map(ControlValueOption.fromJS);
            }
            if (Array.isArray(data['DescriptionFields'])) {
                result.descriptionFields = data['DescriptionFields'];
            }
            if (Array.isArray(data['ValueFields'])) {
                result.valueFields = data['ValueFields'];
            }
        }

        return result;
    }
}

export class FileType {
    group: string = '';
    extensions: string[] = [];

    init(_data?: any): this {
        trySetProp(this, _data, 'Group');
        trySetProp(this, _data, 'Extensions');
        // if (Array.isArray(_data['Extensions'])) {
        //     this.extensions = _data['Extensions'];
        // }

        return this;
    }

    static fromJS(data: any): FileType {
        data = typeof data === 'object' ? data : {};
        return (new FileType()).init(data);
    }
}
